<ng-container *ngrxLet="ntlmLog$ as ntlmLog">
    <div class="log-cinematic-sub-section-ntlm__column-group">
        <!-- 1st column -->
        <div logCinematicSectionColumn>
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.ntlmLabel | vtranslate }}
            </div>
            <div
                logFilter
                *ngIf="ntlmLog.ntlm_detected !== undefined"
                property="ntlm_log.ntlm_detected"
                [value]="ntlmLog.ntlm_detected"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ (ntlmLog.ntlm_detected ? l10nKeys.detectedLabel : l10nKeys.undetectedLabel) | vtranslate }}
            </div>
        </div>

        <!-- 2nd column -->
        <div
            logCinematicSectionColumn
            [expandTwoColumns]="true"
        >
            <div
                logFieldTitle
                [withMarginTop]="false"
            >
                {{ l10nKeys.ntlmStatusLabel | vtranslate }}
            </div>
            <div
                logFilter
                *ngIf="ntlmLog.ntlm_status as ntlmStatus; else na"
                property="ntlm_log.ntlm_status"
                [value]="ntlmStatus"
                (onFilterAdd)="logCinematicStore.closeCinematic()"
            >
                {{ ntlmStatusHash[ntlmStatus] }}
            </div>
        </div>
    </div>

</ng-container>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
